export const faq = {
  title: 'Domande Frequenti',
  subtitle: 'Trova risposte alle domande comuni sui nostri servizi',
  categories: {
    general: {
      title: 'Domande Generali',
      questions: [
        {
          question: 'Quali metodi di pagamento accettate?',
          answer: 'Accettiamo carte di credito, PayPal e bonifici bancari. Tutti i pagamenti sono elaborati in modo sicuro attraverso il nostro gateway di pagamento.'
        },
        {
          question: 'Offrite rimborsi?',
          answer: 'Sì, offriamo una garanzia di rimborso di 14 giorni per la maggior parte dei nostri servizi. Termini specifici si applicano a servizi diversi.'
        },
        {
          question: 'Dove si trovano i vostri server?',
          answer: 'I nostri datacenter principali si trovano in Italia (Milano) e Germania (Francoforte), fornendo una copertura ottimale per gli utenti europei.'
        },
        {
          question: 'Come posso creare un account?',
          answer: 'Puoi creare facilmente un account attraverso la nostra area clienti. Basta cliccare su "Registrati" e seguire i passaggi per configurare il tuo account.'
        },
        {
          question: 'Quali valute accettate?',
          answer: 'Fatturiamo principalmente in Euro (€), ma accettiamo anche pagamenti in USD ($) e GBP (£).'
        }
      ]
    },
    technical: {
      title: 'Supporto Tecnico',
      questions: [
        {
          question: 'Come posso contattare il supporto tecnico?',
          answer: 'Il nostro team di supporto tecnico è disponibile 24/7 attraverso il nostro sistema di ticket, email e supporto telefonico.'
        },
        {
          question: 'Qual è la vostra garanzia di uptime?',
          answer: 'Garantiamo il 99,99% di uptime per tutti i nostri servizi, supportato dal nostro SLA (Service Level Agreement).'
        },
        {
          question: 'Fornite protezione DDoS?',
          answer: 'Sì, tutti i nostri servizi includono protezione DDoS avanzata fino a 4 Tbps senza costi aggiuntivi.'
        },
        {
          question: 'Qual è il vostro tempo medio di risposta per i ticket di supporto?',
          answer: 'Il nostro tempo medio di risposta è inferiore a 30 minuti per problemi urgenti e entro 2 ore per i ticket di supporto regolari.'
        },
        {
          question: 'Offrite supporto gestito?',
          answer: 'Sì, offriamo pacchetti di supporto gestito per tutti i nostri servizi di hosting, inclusi manutenzione server, aggiornamenti e monitoraggio della sicurezza.'
        }
      ]
    },
    hosting: {
      title: 'Servizi di Hosting',
      questions: [
        {
          question: 'Posso aggiornare il mio piano di hosting successivamente?',
          answer: 'Sì, puoi facilmente aggiornare il tuo piano di hosting in qualsiasi momento attraverso la nostra area clienti.'
        },
        {
          question: 'Offrite servizi di migrazione del sito web?',
          answer: 'Sì, offriamo servizi di migrazione del sito web gratuiti per tutti i piani di hosting.'
        },
        {
          question: 'Quale pannello di controllo utilizzate?',
          answer: 'Utilizziamo cPanel per il web hosting e Pterodactyl Panel per i server di gioco.'
        },
        {
          question: 'Con che frequenza eseguite i backup?',
          answer: 'Eseguiamo backup giornalieri per tutti i servizi di hosting e i backup vengono conservati per 30 giorni.'
        },
        {
          question: 'Posso ospitare più domini su un account?',
          answer: 'Sì, i nostri piani Business e Professional supportano domini illimitati.'
        }
      ]
    },
    gameServers: {
      title: 'Server di Gioco',
      questions: [
        {
          question: 'Quanto velocemente vengono attivati i server di gioco?',
          answer: 'I server di gioco vengono attivati istantaneamente dopo la conferma del pagamento.'
        },
        {
          question: 'Posso installare mod personalizzate?',
          answer: 'Sì, tutti i nostri server di gioco supportano mod e plugin personalizzati attraverso il Pterodactyl Panel.'
        },
        {
          question: 'Offrite backup per i server di gioco?',
          answer: 'Sì, eseguiamo backup giornalieri di tutti i server di gioco e puoi anche creare backup manuali attraverso il pannello di controllo.'
        },
        {
          question: 'Qual è il numero minimo di slot del server?',
          answer: 'Il numero minimo di slot varia per gioco. Minecraft parte da 10 slot, Rust da 50 slot e CS2 da 12 slot.'
        },
        {
          question: 'Posso cambiare gioco sul mio server?',
          answer: 'Sì, puoi passare tra i giochi supportati in qualsiasi momento attraverso il pannello di controllo.'
        }
      ]
    },
    security: {
      title: 'Sicurezza e Privacy',
      questions: [
        {
          question: 'Come proteggete i dati dei clienti?',
          answer: 'Implementiamo misure di sicurezza standard del settore, inclusi crittografia, firewall e audit di sicurezza regolari.'
        },
        {
          question: 'Offrite certificati SSL?',
          answer: 'Sì, forniamo certificati SSL gratuiti per tutti i piani di hosting attraverso Let\'s Encrypt.'
        },
        {
          question: 'Come gestite la conformità GDPR?',
          answer: 'Siamo pienamente conformi al GDPR e implementiamo tutte le misure necessarie per proteggere i dati degli utenti secondo le normative UE.'
        },
        {
          question: 'Quali opzioni di backup sono disponibili?',
          answer: 'Offriamo sia backup automatici giornalieri che opzioni di backup manuale, con funzionalità di ripristino semplice.'
        },
        {
          question: 'Come gestite gli incidenti di sicurezza?',
          answer: 'Abbiamo un team di sicurezza dedicato che monitora la nostra infrastruttura 24/7 e risponde immediatamente a qualsiasi incidente di sicurezza.'
        }
      ]
    }
  }
};